import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from "react-router-dom";
import ChatProvider from "./Context/ChatProvider";

//Code for service worker to enable PWA features
// if ('serviceWorker' in navigator) {
//     window.addEventListener('load', () => {
//         navigator.serviceWorker.register('/service-worker.js', { scope: '/' })
//            .then(reg => {
//                 // We force SW to update faster
//                 reg.onupdatefound = () => {
//                     const installingWorker = reg.installing;
//                     installingWorker.onstatechange = () => {
//                         if (installingWorker.state === 'installed') {
//                             if (navigator.serviceWorker.controller) {
//                                 console.log('New SW found, reload the page.');
//                             }
//                         }
//                     };
//                 };
//             });
//     });
// }

if ('serviceWorker' in navigator) {
    let refreshing = false; // Flag to prevent reload loops
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/service-worker2.js')
            .then(reg => {
                // Monitor the service worker lifecycle
                reg.onupdatefound = () => {
                    const installingWorker = reg.installing;
                    installingWorker.onstatechange = () => {
                        // Check if the new worker has finished installing
                        if (installingWorker.state === 'installed') {
                            // If there is an existing controller, it means we have an update
                            if (navigator.serviceWorker.controller) {
                                console.log('New SW found. Attempting safe reload...');                         
                                // Prevent infinite loop using the flag
                                if (!refreshing) {
                                    refreshing = true;
                                    window.location.reload();
                                }
                            }
                        }
                    };
                };
            })
            .catch(err => console.error('SW registration failed:', err));
    });
}


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
        <BrowserRouter>
            <ChatProvider >
                <App />
            </ChatProvider>
        </BrowserRouter>
);

// reportWebVitals();